// const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:1337';
const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_STRAPI_URL
    : process.env.REACT_APP_DEV_STRAPI_URL;

export default baseURL;
